import { FC, useState } from "react";
import closeIcon from "./icons/close.png";
import diamondIcon from "./icons/diamond1.png";
import diamond2Icon from "./icons/diamond2.png";
import styles from "./AchievementItem.module.scss";
import { TItemType } from "./AchievementCard";
import { shortNumberForm } from "../../utils/numbers";
import { InfoSnackbar } from "../InfoSnackbar/InfoSnackbar";

interface IAchievementItemProps {
    type: TItemType;
    index: number;
    tips: string;

    currentValue?: number;
    targetValue?: number;
}

export const AchievementItem: FC<IAchievementItemProps> = ({ type, index, tips, currentValue, targetValue }) => {
    const [infoMessage, setInfoMessage] = useState('');

    const getImage = (icon: string, style?: string, image?: string, content?: string, pending?: boolean) => {
        let sizeStyle = styles.little;
        if (content && content.length < 13)
            sizeStyle = styles.small;
        else if (content && content.length < 10)
            sizeStyle = styles.normal;

        return (
            <div className={ style }>
                <img
                    src={ icon }
                    alt={`diamond${index}`}
                    className={ image }
                />
                <span className={`${styles.diamondText} ${sizeStyle}`}>
                    { content }
                </span>
            </div>
        );
    }

    const getCompleted = () => getImage(diamondIcon, styles.diamondBlock, styles.diamondImg, targetValue?.toString());

    const getProgress = () => {
        const cont = `${shortNumberForm(currentValue!, 2)} / ${shortNumberForm(targetValue!, 2)}`;
        return getImage(diamond2Icon, styles.diamondBlock, styles.diamondImg, cont, currentValue === targetValue)
    };

    const getItemContent = () => {
        switch (type) {
            case 'completed': return getCompleted();
            case 'progress': return getProgress();
            case 'close': return getImage(closeIcon);
        }
    }

    return (
        <div
            key={`item${index}`}
            className={`${styles.item} ${styles[type]}`}
            onClick={ tips ? () => setInfoMessage(tips) : () => {} }
        >
            { getItemContent() }

            {infoMessage.length > 0 && <InfoSnackbar infoMessage={infoMessage} onCloseHandler={() => setInfoMessage('')} />}
        </div>
    );
}